import { render, staticRenderFns } from "./SparePartTile.vue?vue&type=template&id=246489a9&scoped=true&"
import script from "./SparePartTile.ts?vue&type=script&lang=ts&"
export * from "./SparePartTile.ts?vue&type=script&lang=ts&"
import style0 from "./SparePartTile.vue?vue&type=style&index=0&id=246489a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246489a9",
  null
  
)

export default component.exports